import { render, staticRenderFns } from "./DrawerFooter.vue?vue&type=template&id=9b7e2c38&scoped=true"
import script from "./DrawerFooter.vue?vue&type=script&lang=js"
export * from "./DrawerFooter.vue?vue&type=script&lang=js"
import style0 from "./DrawerFooter.vue?vue&type=style&index=0&id=9b7e2c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7e2c38",
  null
  
)

export default component.exports